/* stylelint-disable max-line-length */

/*
 * @prop --component-progress-bar-color-line: The color of the progress bar line between steps
 * @prop --component-progess-bar-color-count-background: The background-color of the progress bar item count circle
 * @prop --component-progess-bar-color-count-text: The text color of the progress bar item count circle
 * @prop --component-progess-bar-color-active-icon: The icon color of a progress bar active icon
 * @prop --component-progess-bar-color-active-icon-background: The background color of a progress bar active icon
*/

ui-cms-progress-bar {
  display: block;

  & sd-scrollable::part(scroll-content) {
    display: flex;
    justify-content: space-between;
  }

  & sd-scrollable {
    &::part(button-right),
    &::part(button-left) {
      align-items: start;
      padding-top: $sd-spacing-6;
      width: 200px;
    }

    &::part(button-right) {
      justify-content: end;
    }

    &::part(button-left) {
      justify-content: start;
    }
  }

  .progress-step {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: auto;
    text-align: center;
    text-wrap: auto;

    &--small {
      width: var(--dynamic-width);
    }

    &--medium {
      min-width: calc(100% / 3);
    }

    &--large {
      min-width: 25%;
    }

    &--medium,
    &--large {
      --symbol-width: 72px;

      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: calc(var(--symbol-width) / 2);
        left: calc(50% + calc(var(--symbol-width) / 2));
        width: calc(100% - var(--symbol-width));
        height: 1px;
        background-color: var(
          --component-progress-bar-color-line,
          var(--skin-color-secondary, $sd-borderColor-neutral-400)
        );
      }

      &:last-child::after {
        display: none;
      }
    }

    &__symbol {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      height: 72px;
      width: 72px;
      margin: $sd-spacing-0 auto $sd-spacing-2;
      border-radius: 100%;

      sd-icon {
        font-size: $sd-fontSize-3xl;
      }

      &--icon {
        border: 1px solid
          var(--component-progress-bar-color-line, var(--skin-color-secondary, $sd-borderColor-neutral-400));
      }

      &--count {
        border: 1px solid
          var(--component-progress-bar-color-line, var(--skin-color-secondary, $sd-borderColor-neutral-400));
        color: var(--component-progess-bar-color-count-text, var(--skin-color-primary, $sd-textColor-primary-DEFAULT));
        font-size: $sd-fontSize-xl;
        padding-bottom: $sd-spacing-1;
      }
    }

    &__activeIcon {
      --component-icon-color: var(
        --component-progess-bar-color-active-icon,
        var(--skin-color-white, $sd-textColor-white)
      );

      display: none;
      position: absolute;
      bottom: -3px;
      right: -3px;
      height: 24px;
      width: 24px;
      background-color: var(
        --component-progess-bar-color-active-icon-background,
        var(--skin-color-accent, $sd-borderColor-accent-DEFAULT)
      );
      padding: $sd-spacing-1;
      border-radius: 100%;

      sd-icon {
        font-size: $sd-fontSize-base;
      }
    }

    &__headline {
      display: block;
      margin-bottom: $sd-spacing-1;
      text-align: center;
      justify-content: center;
    }

    &__text {
      margin-bottom: $sd-spacing-4;
      text-align: center;
      justify-content: center;
    }

    &__button {
      align-self: center;

      &__alignLink {
        margin-top: auto;
      }

      &--plain {
        margin-bottom: $sd-spacing-6;
      }
    }

    &--active {
      .progress-step__activeIcon {
        display: flex;
      }
    }
  }

  .sr-only {
    @include sr-only;
  }
}
